import React, { Component } from 'react'

import classNames from 'classnames';

import { connect } from 'react-redux';

import {Button, InputGroup, Col, Row} from 'react-bootstrap';

import ProductSelectedInfo from 'components/ProductSelectedInfo/ProductSelectedInfo';
import CustomerTypeahead from 'components/Typeaheads/CustomerTypeahead';
import PaymentCondSelect from 'components/PaymentCondSelect/PaymentCondSelect';
import TermYearsSelect from 'components/TermYearsSelect/TermYearsSelect';
import CampaignSelect from 'components/CampaignSelect/CampaignSelect';
import PaymentPlanTable from 'components/PaymentPlanTable/PaymentPlanTable';
import SaleProjection from 'components/SaleProjection/SaleProjection';
import CustomerModal from 'components/CustomerModal/CustomerModal';
import Loader from "components/elements/loader/Loader";

import {
  updateCustomer,
  updateYearsPayment,
  updateCampaign,
  updateInitialQuota,
  updatePaymentCondition,
  negotiateSaleOrder,
  cleanNegotiate,
  fetchSecondSaleOrderQualification,
  saveSaleOrder
} from 'reducers/saleorder/saleorderActions';
import { showWarningMessage, showSuccessfulMessage } from 'reducers/application/applicationActions';
import NumberFormat from "react-number-format";

class NegotiationStep extends Component {

  constructor(props) {
    super(props);

    this.state = {
      customerError: null,
      yearsPaymentError: null,
      paymentConditionError: null,
      amountError: null,
      campaignError: null,
      showCustomerModal: false,
      loading: false,
      isSecondSaleOrMore: false,
      initialQuotaNew: 0
    }
  }

  componentWillMount() {
    if (this.props.customer != null && !this.props.productEdit) {

      this.props.negotiateSaleOrder(this.props.customer, this.props.product,
          this.props.paymentCondition.value, this.props.yearsPayment !=null ? this.props.yearsPayment.value: null,
          this.props.campaign != null ? this.props.campaign.value : null,
          this.props.initialQuota);
    }
    this.props.fetchSecondSaleOrderQualification();
  }

  isValidated() {
    this.cleanErrors();
    if (this.props.customer == null) {
      this.props.showWarningMessage("Por favor busque un cliente");
      this.setState({ customerError: "Por favor busque un cliente" });
      return;
    }

    if (!this.validatePaymentConditions()) return;

    if (!this.props.productEdit) {
      this.props.jumpToStep(2);
    }

    return true;
  }

  saveForSecondSaleOrMore() {
    this.cleanErrors();
    if (!this.validatePaymentConditions()) return;
    if (!this.props.productEdit) {
      let promise = new Promise((resolve, reject) => {
        this.setState({ loading: true });
        this.saveSecondSaleOrder(resolve, reject);
      });

      promise.then(() => {
        this.setState({ loading: false });
        this.props.jumpToStep(3);
      }, () => {
        this.setState({ loading: false });
      })
    }
    return true;
  }

  saveSecondSaleOrder(resolve, reject) {
    let saleOrderDto = this.buildSaleOrderDto();
    this.props.saveSaleOrder(saleOrderDto, resolve, reject);
  }

  buildSaleOrderDto() {
    return {
      customerId: undefined,
      productId: this.props.product.id,
      paymentConditionsType: this.props.paymentCondition.value,
      yearsPayment: this.props.yearsPayment.value,
      campaign : this.props.campaign.value,
      nodeIdSelected: undefined
    }
  }

  validatePaymentConditions() {
    if (this.props.paymentCondition == null) {
      this.props.showWarningMessage("Por favor seleccionar Condición de pago");
      this.setState({ paymentConditionError: "Por favor seleccionar Condición de pago" });
      return false;
    }

    if (this.props.paymentCondition.value === "CREDIT" && this.props.yearsPayment == null) {
      this.props.showWarningMessage("Por favor seleccionar cantidad de años a pagar");
      this.setState({ yearsPaymentError: "Por favor seleccionar cantidad de años a pagar" });
      return false;
    }
    return true;
  }


  cleanCustomerError() {
    this.setState({ customerError: null });
  }

  cleanAmountError() {
    this.setState({ amountError: null });
  };

  cleanPaymentConditionError() {
    this.setState({ paymentConditionError: null });
  }

  cleanYearsPaymentError() {
    this.setState({ yearsPaymentError: null });
  }

  cleanCampaignError() {
    this.setState({ campaignError: null });
  }

  cleanErrors() {
    this.cleanCustomerError();
    this.cleanPaymentConditionError();
    this.cleanYearsPaymentError();
    this.cleanAmountError();
  }

  handleCustomerSelectionChange(selectedCustomer) {

    if (selectedCustomer != null) {
      this.cleanCustomerError();
    } else {
      this.props.cleanNegotiate();
    }
    this.props.updateCustomer(selectedCustomer);
  }


  handlePaymentConditionChange(paymentCondition) {
    if (paymentCondition != null) {
      this.cleanPaymentConditionError();
      if (paymentCondition.value === 'CASH'){
        this.props.negotiateSaleOrder(this.props.customer, this.props.product, paymentCondition.value, 0,null);
      }else {
        if (this.props.yearsPayment != null){
          this.props.negotiateSaleOrder(this.props.customer, this.props.product, paymentCondition.value, this.props.yearsPayment.value,this.props.campaign != null ? this.props.campaign.value : null, this.props.initialQuota);
        }
      }
    } else {
      this.props.updateYearsPayment(null);
      this.props.updateCampaign(null);
      this.props.updateInitialQuota(0);
    }
    this.props.updatePaymentCondition(paymentCondition);
  }

  handleYearsPaymentSelectionChange(yearsPayment) {
    console.log("yearsPayment", yearsPayment);
    if (yearsPayment != null) {
      this.cleanYearsPaymentError();
    }
    this.props.updateYearsPayment(yearsPayment);
    this.props.negotiateSaleOrder(this.props.customer, this.props.product, this.props.paymentCondition.value, yearsPayment.value, this.props.campaign != null ? this.props.campaign.value : null, this.state.initialQuota);
  }

  handleCampaignSelectionChange(campaign) {
    if (campaign != null) {
      this.cleanCampaignError();
    }
    this.props.updateCampaign(campaign);
    this.props.negotiateSaleOrder(this.props.customer, this.props.product, this.props.paymentCondition.value, this.props.yearsPayment != null ? this.props.yearsPayment.value: null, campaign != null ? campaign.value: null, this.state.initialQuota);
  }

  handleSaveInitialQuota = () => {
    this.handleInitialQuotaChange(this.state.initialQuotaNew);
  };

  handleInitialQuotaChange(initialQuota) {
    if (initialQuota != null) {
      this.cleanAmountError();
    }
      this.props.updateInitialQuota(initialQuota);
      this.props.negotiateSaleOrder(this.props.customer, this.props.product, this.props.paymentCondition.value, this.props.yearsPayment != null ? this.props.yearsPayment.value: null, this.props.campaign != null ? this.props.campaign.value: null, initialQuota);
  }

  updateNegotiation() {
    if (this.isValidated()) {
      this.setState({ loading: true });
      let promise = new Promise((resolve, reject) => {
        this.props.updateNegotiation(this.props.saleOrderId, this.props.customer,
          this.props.product, this.props.paymentCondition.value,
          this.props.yearsPayment.value, this.props.campaign != null ? this.props.campaign.value : 0, resolve, reject);
      })

      promise.then(() => {
        this.setState({ loading: false });
        this.props.showSuccessfulMessage("Negociación actualizada correctamente");
      }, () => {
        this.setState({ loading: false });
      });
    }
  }

  isNegotiationEditable = () => {
    if (this.props.orderStatus) {
      return this.props.orderStatus === 'DRAFT' || this.props.orderStatus === 'PRODUCT_RESERVED';
    }
    return true;
  }

  handleSecondSaleOrderChange = (evt) => {
    this.setState({ isSecondSaleOrMore: evt.target.checked });
    if (evt.target.checked) {
      this.props.negotiateSaleOrder(undefined, this.props.product, this.props.paymentCondition.value, this.props.yearsPayment.value);
    } else {
      this.props.cleanNegotiate();
    }
  }

  render() {
    const { customerError, yearsPaymentError, paymentConditionError, campaignError } = this.state;
    const customerClass = classNames('form-group',
      { 'has-error': customerError != null }
    );
    const yearsPaymentClass = classNames('form-group',
      { 'has-error': yearsPaymentError != null }
    );
    const paymentConditionClass = classNames('form-group',
      { 'has-error': paymentConditionError != null }
    );
    const campaignClass = classNames('form-group',
        { 'has-error': campaignError != null }
    );
    let customerModalClose = () => this.setState({ showCustomerModal: false });

    let nextButton = !this.state.isSecondSaleOrMore ?
      <Button className="bg-light-secondary"
        onClick={() => this.isValidated()}>
        Siguiente
      </Button> :
      <Button className="bg-light-secondary"
        disabled={this.state.loading}
        onClick={() => this.saveForSecondSaleOrMore()}>
        Guardar
      </Button>;
    return (
      <Col className="wizard-step">

        {!this.props.productEdit ?
          <Row className="wizard-buttons justify-content-between">
            <Button className="bg-light-secondary"
              disabled={this.state.loading}
              onClick={() => this.props.jumpToStep(0)}>
              Atrás
                    </Button>
            {nextButton}
          </Row>
          :
          <Row className={this.isNegotiationEditable() ? "wizard-buttons justify-content-end" : "hide"}>
            <Button className="bg-light-secondary"
              disabled={this.state.loading}
              onClick={() => this.updateNegotiation()}>
              Guardar
            </Button>
          </Row>
        }

        <Loader show={true} classes={this.state.loading ? "map-default-height" : "d-none"} />
        <div className={this.state.loading ? "d-none" : "row"}>
          <div className="col-xl-5 no-padding">
            <div className="col-md-12 sales__heading ">
              <h5 className="">Resumen</h5>
              <div className="wizard-inner-form-padding">
                {this.props.product != null &&
                  <ProductSelectedInfo product={this.props.product} />
                }
              </div>
            </div>

            <div className="col-md-12">
              <div className="wizard-inner-form-padding">

                {(this.props.enabledForSecondSale && this.isNegotiationEditable() ) &&
                  <div className="form-group">
                    <div className={'form-check'}>
                      <input type="checkbox" onChange={this.handleSecondSaleOrderChange}
                        type="checkbox" checked={this.state.isSecondSaleOrMore}
                        class="form-check-input" id="checkSecondSale" />
                      <label class="form-check-label" for="checkSecondSale"><b>Compra tu segundo terreno o más</b></label>
                    </div>
                  </div>
                }

                {!this.state.isSecondSaleOrMore &&
                  <div className={customerClass}>
                    <InputGroup>
                      <CustomerTypeahead
                        disabled={!this.isNegotiationEditable()}
                        onRef={ref => (this.productTypeahead = ref)}
                        selection={this.props.customer}
                        handleChange={(customer) => this.handleCustomerSelectionChange(customer)} />
                      <InputGroup.Button>
                        <Button className="border-radius-right"
                          disabled={!this.isNegotiationEditable()}
                          onClick={() => this.setState({ showCustomerModal: true })}
                          bsSize="small"
                          bsStyle="primary">+</Button>
                      </InputGroup.Button>
                    </InputGroup>
                    <span className="help-block">{customerError}</span>
                  </div>
                }

                {(this.props.customer != null || this.state.isSecondSaleOrMore) &&
                  <div className={paymentConditionClass}>
                    <PaymentCondSelect
                      disabled={!this.isNegotiationEditable()  || this.props.product.isInversion === 'true'}
                      cashSale={this.props.product.cashSale === 'true'}
                      creditSale={this.props.product.creditSale === 'true'}
                      selection={this.props.paymentCondition}
                      handleChange={(paymentCondition) => this.handlePaymentConditionChange(paymentCondition)}
                    />
                    <span className="help-block">{paymentConditionError}</span>
                  </div>
                }

                {(this.props.customer != null || this.state.isSecondSaleOrMore) &&
                  this.props.paymentCondition != null &&
                  this.props.paymentCondition.value === 'CREDIT' &&
                  <div className={yearsPaymentClass}>
                    <TermYearsSelect
                      disabled={!this.isNegotiationEditable()}
                      project={this.props.project}
                      selection={this.props.yearsPayment}
                      handleChange={(yearsPayment) => this.handleYearsPaymentSelectionChange(yearsPayment)}
                    />
                    <span className="help-block">{yearsPaymentError}</span>
                  </div>
                }

                {(this.props.customer != null || this.state.isSecondSaleOrMore) &&
                this.props.paymentCondition != null &&
                this.props.paymentCondition.value === 'CREDIT' &&
                <div className={campaignClass}>
                  <CampaignSelect
                      disabled={!this.isNegotiationEditable()}
                      project={this.props.project}
                      selection={this.props.campaign}
                      handleChange={
                        (campaign) => this.handleCampaignSelectionChange(campaign)
                      }
                  />
                  <span className="help-block">{campaignError}</span>
                </div>
                }

                {(this.props.campaign != null && this.props.customer != null) &&
                this.props.paymentCondition != null &&
                this.props.paymentCondition.value === 'CREDIT' &&
                <div className={campaignClass}>
                  <NumberFormat
                      disabled={this.props.negotiationSaleOrder ? !this.props.negotiationSaleOrder.canEditInitialQuota: true}
                      placeholder={"CUOTA INICIAL"}
                      className="form-control input-sm form-control-sm"
                      value={this.state.initialQuotaNew > 0 ? this.state.initialQuotaNew : this.props.negotiationSaleOrder.initialQuota}
                      decimalScale={1}
                      thousandSeparator={true}
                      suffix={'$'}
                      onValueChange={(values) => {
                        const { value } = values;
                        this.setState({ initialQuotaNew: value })
                      }} />
                  <button
                      type="button"
                      className="btn btn-primary"
                      onClick={this.handleSaveInitialQuota}>
                    >>
                  </button>
                </div>}
              </div>
            </div>


            <CustomerModal
              updateCustomer={(customer) => this.handleCustomerSelectionChange(customer)}
              show={this.state.showCustomerModal}
              onHide={customerModalClose} />

          </div>

          <div className="col-xl-7 no-padding">
            {this.props.negotiationSaleOrder != null &&
            <div className="col-md-12 sales__heading">
              <h5>Proyección</h5>
              <div className="wizard-inner-form-padding">
                <SaleProjection
                    negotiation={this.props.negotiationSaleOrder} />
              </div>
            </div>
            }

            {this.props.negotiationSaleOrder != null &&
            <div className="col-md-12 sales__heading">
              <h5>Plan de Pagos</h5>
              <div className="wizard-inner-form-padding">

                <PaymentPlanTable
                    quotas={this.props.negotiationSaleOrder.quotaList}
                />

              </div>
            </div>
            }
          </div>
        </div>

      </Col>
    )
  }
}
const mapStateToProps = state => ({
  project: state.saleorder.project,
  product: state.saleorder.product,
  customer: state.saleorder.customer,
  yearsPayment: state.saleorder.yearsPayment,
  paymentCondition: state.saleorder.paymentCondition,
  campaign: state.saleorder.campaign,
  negotiationSaleOrder: state.saleorder.negotiationSaleOrder,
  enabledForSecondSale: state.saleorder.enabledForSecondSale,
  initialQuotaNew: state.saleorder.initialQuotaNew
});

export default connect(
  mapStateToProps,
  {
    updateCustomer,
    updateYearsPayment,
    updateCampaign,
    updateInitialQuota,
    showWarningMessage,
    updatePaymentCondition,
    negotiateSaleOrder,
    cleanNegotiate,
    showSuccessfulMessage,
    fetchSecondSaleOrderQualification,
    saveSaleOrder
  },
  null,
  { withRef: true }
)(NegotiationStep);



// WEBPACK FOOTER //
// ./src/components/SalesWizard/Steps/NegotiationStep.jsx